import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  GaRegionSelectDialogComponent,
  GaRegionSelectDialogComponentData,
  GaRegionSelectDialogComponentResult,
} from 'gain-web/shared-modules/ga-region-select/region-select-dialog/region-select-dialog.component';

export type SelectRegionArgs = {
  readonlyRegions?: string[];
  selectedRegions?: string[];
  dialogTitle?: string;
  readOnlyDialog?: boolean;
  countryCode: string;
  considerPuertoRicoAsUnitedStatesRegion?: boolean;
  hiddenRegions?: string[];
};

export type SelectRegionResults =
  | { cancelled: true }
  | { cancelled: false; regions: string[] };

@Injectable({ providedIn: 'root' })
export class RegionSelectService {
  constructor(private _matDialog: MatDialog) {}

  // Invokes the dialog
  public async selectRegions(
    args: SelectRegionArgs,
  ): Promise<SelectRegionResults> {
    const dialogData: GaRegionSelectDialogComponentData = {
      selectedRegions: args.selectedRegions ?? [],
      readonlyRegions: args.readonlyRegions ?? [],
      dialogTitle: args.dialogTitle ?? 'Select regions',
      hiddenRegions: args.hiddenRegions,
      considerPuertoRicoAsUnitedStatesRegion:
        args.considerPuertoRicoAsUnitedStatesRegion,
      countryCode: args.countryCode,
    };

    const ref = this._matDialog.open<
      GaRegionSelectDialogComponent,
      GaRegionSelectDialogComponentData,
      GaRegionSelectDialogComponentResult
    >(GaRegionSelectDialogComponent, {
      minWidth: '900px',
      data: dialogData,
      panelClass: 'region-select-dialog',
    });

    const dialogResults = await ref.afterClosed().toPromise();
    if (dialogResults === 'Close' || !dialogResults) {
      return { cancelled: true };
    }

    return {
      cancelled: false,
      regions: dialogResults.selectedRegions,
    };
  }
}
